import { createContext } from "react"
import React from "react"
import { CadastroAplicativoInicial } from "../models/cadastroAplicativoModel"
import type { CadastroAplicativoModel } from "../models/cadastroAplicativoModel"
import type { CadastroAplicativoActionModel } from "./cadastroAplicativoActions"

type CadastroAplicativoContextProps = {
    dados: CadastroAplicativoModel
    dispatch: React.Dispatch<CadastroAplicativoActionModel>
    salvar: () => Promise<void>
    onEstabelecimentoChange: (idEstabelecimento: number | null) => Promise<void>
    erroCarregamento: string | null
}

const initialContextValue: CadastroAplicativoContextProps = {
    dados: CadastroAplicativoInicial,
    dispatch: () => {},
    salvar: async () => {},
    onEstabelecimentoChange: async () => {},
    erroCarregamento: null,
}

export const CadastroAplicativoContext =
    createContext<CadastroAplicativoContextProps>(initialContextValue)
